module.exports = __webpack_public_path__ + "static/mapVisionPoster-f2a5e119aeac7db24246faf775d91fd9.png";